module.exports = __webpack_public_path__ + "static/media/wellnite-auth-hero_609.59960e61.webp";